import { createFileRoute } from '@tanstack/react-router'
import { OverridesPage } from '@/components/admin-overrides-page'

export const Route = createFileRoute('/admin/overrides')({
  component: OverridesPage,
})
